import { cqrs } from '@faro/http-clients';
import { ObjectiveGroupSequence, toObjectiveGroupSequence } from '@faro/study-designer-model';
import axios from 'axios';
import { Identifiable } from 'faro-common-model';
import { RevisionQueryParameter, StudyPathParameter } from '../parameter';

export type ObjectiveGroupSequencePathParameters = StudyPathParameter;

export interface ObjectiveGroupSequenceQueryParameters extends RevisionQueryParameter {
    /**
     * A comma-separated list of IDs of the {@link ObjectiveGroupSequence} instances to retrieve.
     *
     */
    readonly ids?: string;
}

const factory = cqrs<ObjectiveGroupSequence, ObjectiveGroupSequencePathParameters>(
    '/api/study-designer/studies/:studyId/objective-group-sequences',
    toObjectiveGroupSequence
);

/**
 * Client responsible for accessing the backend entity services
 */
export const objectiveGroupSequenceClient = {
    list: factory.list<ObjectiveGroupSequenceQueryParameters>(),
    get: async (
        request: ObjectiveGroupSequencePathParameters & Identifiable & RevisionQueryParameter,
        signal?: AbortSignal
    ): Promise<ObjectiveGroupSequence> => {
        const { studyId, id, ...params } = request;
        return axios
            .get(`/api/study-designer/studies/${studyId}/objective-group-sequences/${id}`, {
                signal,
                params,
            })
            .then(response => toObjectiveGroupSequence(response.data));
    },
};
